export const DailyHourlyForecastTileDetail = {
  detailTitle: 'daily_hourly_forecast_detail_title',
  detailWeatherIcon: 'daily_hourly_forecast_detail_icon',
  detailTemperature: 'daily_hourly_forecast_detail_temperature',
  detailPrecip: 'hourly_forecast_detail_precip',
  detailNightTemperature: 'daily_forecast_detail_night_temperature',
};
